import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { EventEntity } from './event.entity';
import { UserEntity } from './user.entity';

@Index('event_user__fk_user__id_fk', ['fkUserId'], {})
@Index('event_user_pk', ['fkEventId', 'fkUserId'], { unique: true })
@Entity('event_user')
export class EventUserEntity extends BaseEntity {
	@Column('int', { name: '_fk__event__id', unsigned: true })
	public fkEventId!: number;

	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@ManyToOne(() => UserEntity, (user) => user.eventUsers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;

	@ManyToOne(() => EventEntity, (event) => event.eventUsers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__event__id', referencedColumnName: 'id' }])
	public fkEvent!: EventEntity;
}
